export default function DevIndicator() {
    return <>{process.env.NODE_ENV === "development" && <div className="env-info">DEV</div>}</>;
}
